import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import keyboardKey from 'keyboard-key';
import Input from '../../../components/Input';
import Icon from '../../../components/Icon';

import messages from '../messages';
import '../styles.css';

export class LocationInputComponent extends React.PureComponent {
  static propTypes = {
    intl: PropTypes.shape({
      formatMessage: PropTypes.func.isRequired,
    }).isRequired,
    inputId: PropTypes.string,
    accessibilityLabel: PropTypes.string,
    selectedLocation: PropTypes.object,
    virtual: PropTypes.bool,
    onLocationInputChanged: PropTypes.func.isRequired,
    onLocationInputKeyDown: PropTypes.func.isRequired,
    setLocationInputReference: PropTypes.func.isRequired,
  };

  static getDerivedStateFromProps(props, state) {
    const selectedLocation = props.selectedLocation || {};
    const locationName = selectedLocation.name || '';
    const input = locationName !== state.locationName ? locationName : state.input;
    return { locationName, input };
  }

  constructor(props) {
    super(props);
    this.state = {
      input: '',
      locationName: '',
    };
  }

  onInputChanged = (event) => {
    const input = event.target.value;
    this.setState({ input });
    this.props.onLocationInputChanged(input);
  }

  render() {
    const placeholder = this.props.intl.formatMessage(messages.searchInputPlaceholder);
    return (
      <Input
        icon
        value={this.props.virtual ? '' : this.state.input}
        onChange={this.onInputChanged}
        styleName="location-input"
        onKeyDown={(event) => this.props.onLocationInputKeyDown(keyboardKey.getCode(event))}
      >
        <Icon name="search" />
        <input
          id={this.props.inputId}
          data-cy="location-name-input"
          type="text"
          name="locations-dropdown"
          autoComplete="off"
          disabled={this.props.virtual}
          aria-label={`${this.props.accessibilityLabel} - ${placeholder}`}
          placeholder={placeholder}
          ref={this.props.setLocationInputReference}
        />
      </Input>
    );
  }
}

export default injectIntl(LocationInputComponent);
